import React from 'react';
import Svg from '../Svg';

const IconCurrencyYenCircle = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM7.37531 6.21913C7.80657 5.87412 8.43586 5.94404 8.78087 6.37531L12 10.3992L15.2191 6.37531C15.5641 5.94404 16.1934 5.87412 16.6247 6.21913C17.056 6.56414 17.1259 7.19343 16.7809 7.62469L14.0806 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V14H15.5C16.0523 14 16.5 14.4477 16.5 15C16.5 15.5523 16.0523 16 15.5 16H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V16H8.5C7.94772 16 7.5 15.5523 7.5 15C7.5 14.4477 7.94772 14 8.5 14H11V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H9.91938L7.21913 7.62469C6.87412 7.19343 6.94404 6.56414 7.37531 6.21913Z"
    />
  </Svg>
);

export default IconCurrencyYenCircle;
